import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type SafetyDocumentsProps = {
    signalWord: string;
    safetyIcons: Array<any>;
    hazardStatements: string;
    precautionaryStatements: string;
    sdsUrl: string;
    dopUrl: string;
    isReadMoreDataAvailable: boolean;
};

const SafetyDocuments = ({
    signalWord,
    safetyIcons,
    hazardStatements,
    precautionaryStatements,
    sdsUrl,
    dopUrl,
    isReadMoreDataAvailable,
}: SafetyDocumentsProps) => {
    const { t } = useGranite();

    return (
        <div className="js-product-features safety-component mb-3">
            <section className="feature-list-component mb-3 js-product-features">
                <div className="col-12 border-bottom border-primary">
                    <div className="py-2 font-weight-bold">
                        {t("productDetail.safetyList.title")}
                    </div>
                </div>
                <div className="feature-list-component__list">
                    {signalWord && (
                        <div className="col-12 feature-list-component__item">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.signalWord",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div
                                        className="py-2"
                                        dangerouslySetInnerHTML={{
                                            __html: signalWord,
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )}
                    {safetyIcons.length > 0 && (
                        <div className="col-12 feature-list-component__item">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.safetyIcons",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div className="row py-2">
                                        {safetyIcons.map(
                                            (safetyIcon, index) => {
                                                return (
                                                    <div
                                                        className="col-3"
                                                        key={`safety-${index}`}
                                                    >
                                                        <img
                                                            src={safetyIcon.url}
                                                            alt={
                                                                safetyIcon.altText
                                                            }
                                                        />
                                                    </div>
                                                );
                                            },
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!!hazardStatements && (
                        <div className="col-12 feature-list-component__item">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.hazardStatements",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div
                                        className="py-2"
                                        dangerouslySetInnerHTML={{
                                            __html: hazardStatements,
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!!precautionaryStatements && (
                        <div className="col-12 feature-list-component__item js-product-features__list--overflow d-none">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.precautionaryStatements",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div
                                        className="py-2"
                                        dangerouslySetInnerHTML={{
                                            __html: precautionaryStatements,
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!!sdsUrl && (
                        <div className="col-12 feature-list-component__item js-product-features__list--overflow d-none">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.sds.title",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div className="py-2">
                                        <a
                                            href={sdsUrl}
                                            target="_blank"
                                            className="btn-link"
                                        >
                                            {t(
                                                "productDetail.safetyList.sds.link",
                                            )}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!!dopUrl && (
                        <div className="col-12 feature-list-component__item js-product-features__list--overflow d-none">
                            <div className="row border-bottom ">
                                <div className="col-6 feature-list-component__item--gray">
                                    <div className="py-2">
                                        {t(
                                            "productDetail.safetyList.dop.title",
                                        )}
                                    </div>
                                </div>
                                <div className="col-6 bg-light">
                                    <div className="py-2">
                                        <a
                                            href={dopUrl}
                                            target="_blank"
                                            className="btn-link"
                                        >
                                            {t(
                                                "productDetail.safetyList.dop.link",
                                            )}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {isReadMoreDataAvailable && (
                    <div className="feature-list-component__button col-12 my-2">
                        <a
                            href="#"
                            className="js-product-feature-list__link--less d-none btn-link"
                        >
                            {t("productDetail.featureList.link.showLess")}{" "}
                            <i className="las la-angle-up ml-1"></i>
                        </a>
                        <a
                            href="#"
                            className="js-product-feature-list__link--more btn-link"
                        >
                            {t("productDetail.featureList.link.showMore")}{" "}
                            <i className="las la-angle-down ml-1"></i>
                        </a>
                    </div>
                )}
            </section>
        </div>
    );
};

export { SafetyDocuments };
